import React from 'react';
import PropTypes from 'prop-types';

import { Cover, Layout, Link, SectionCompareWrap, SectionTopics, SEO } from 'components';
import { routes } from 'utils/routes';
import { media } from "utils/media";
import mdToHtml from "utils/mdToHtml";
import { cta } from 'utils/cta';
// Content
import contentSEO from "cms/content/teeth-straightening-comparator-seo.yml";
import contentCover from "cms/content/teeth-straightening-comparator-cover.yml";
import contentCompare from "cms/content/teeth-straightening-comparator-compare.yml";

const ComparePage = ({ pageContext: { locale }, location }) => (
  <Layout locale={locale}>
    <SEO
      title={contentSEO.title}
      description={contentSEO.description}
      lang={locale}
      keywords={contentSEO.keywords}
      location={location}
      image={contentSEO.socialImage}
    />

    <Link to={routes.apart.path} {...routes.apart} className='cta-sidetab'>What sets us apart?</Link>

    <Cover
      title={contentCover.title}
      text={mdToHtml(contentCover.text)}
      image={{ url: media(contentCover.image), alt: 'Invisible braces at home' }}
      className='bg-img-grid-faded'
    />

    <div className='flex-center mb-40'>
      <Link to={routes.getStarted.path} {...routes.getStarted} className='button cta-comparison'>{cta.getStarted}</Link>
    </div>

    <SectionTopics locale={locale} />
    <SectionCompareWrap compareData={contentCompare.steps} locale={locale} />
  </Layout>
);

ComparePage.propTypes = {
  pageContext: PropTypes.shape({
    locale: PropTypes.string.isRequired,
  }).isRequired,
};

export default ComparePage;
